import { Input } from "antd";
import PropTypes from "prop-types";
import { MdCheck, MdPriorityHigh, MdLock } from "react-icons/md";
import classnames from "classnames";
import Label from "shared/components/Label";

const Phone = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  labelSuffix,
  innerRef,
  required,
  direction,
  optional,
  right,
  success,
  showSuccessIcon = true,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        "input__wrapper",
        {
          __error: touched && errors,
          __success: success && !errors,
        },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        labelSuffix={labelSuffix}
        required={required}
        optional={optional}
        right={right}
      />
      <div className={`input__wrapper--field`}>
        <Input
          type="phone"
          inputMode="numeric"
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          {...rest}
        />

        {touched && errors && (
          <MdPriorityHigh className="input--error-icon" size={20} />
        )}

        {success && showSuccessIcon && !errors && (
          <MdCheck className="input--success-icon" size={20} />
        )}

        {rest.disabled && !touched && (
          <MdLock className="input--disabled-icon" size={16} />
        )}

      </div>
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  );
};

Phone.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Phone.defaultProps = {
  label: "",
  placeholder: "",
};
export default Phone;
